import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

// Keyframes for neon glow animation
const neonGlow = keyframes`
  0%, 100% {
    box-shadow: 0 0 10px #4F51DF, 0 0 20px #4F51DF, 0 0 30px #4F51DF, 0 0 40px #4F51DF;
  }
  50% {
    box-shadow: 0 0 20px #FFD700, 0 0 30px #FFD700, 0 0 40px #FFD700, 0 0 50px #FFD700;
  }
`;

// Keyframes for flashing button
const flashing = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

const StyledStartPage = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(circle, #222222, #000000);
  position: relative;
  opacity: ${props => (props.visible ? 1 : 0)};
  transition: opacity 0.5s ease; /* Fade-in transition */
`;

const StartButton = styled.button`
  font-size: 2.5em;
  font-family: 'Press Start 2P', sans-serif;
  border: none;
  padding: 20px 80px;
  color: #FFD700; /* Neon yellow */
  background: linear-gradient(45deg, #4F51DF, #FFD700);
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease;
  border-radius: 12px;
  animation: ${neonGlow} 1.5s infinite alternate;
  z-index: 1;

  :hover {
    transform: scale(1.1);
  }

  :focus {
    outline: none;
  }

  ::after {
    content: "Press Start";
    font-size: 0.8em;
    color: #FFF;
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.8;
    animation: ${flashing} 1s infinite;
  }
`;

const GlowEffect = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(79, 81, 223, 0.5), transparent 70%);
  transform: translate(-50%, -50%);
  z-index: 0;
`;

const StartPage = ({ startClick }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);
    
    // Delay showing the content for smooth transition
    const timer = setTimeout(() => {
      setVisible(true); // Show content after scrolling to top
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <StyledStartPage visible={visible}>
      <GlowEffect />
      <StartButton onClick={startClick}>Start</StartButton>
    </StyledStartPage>
  );
};

export default StartPage;

